export const SCOPED_OBJECT_COMMENT_FIELDS = Object.freeze([
	{ key: 'networkComment', label: 'Комментарий для сети' },
	{ key: 'partnerComment', label: 'Комментарий для партнёров' },
	{ key: 'internalComment', label: 'Внутренний комментарий' },
])

const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value || {}, key)

// A missing field is a server visibility decision. This helper deliberately
// reads only the cumulative DTO fields, never their legacy details aliases.
export function scopedObjectComments(object) {
	return SCOPED_OBJECT_COMMENT_FIELDS
		.filter(({ key }) => hasOwn(object, key) && typeof object[key] === 'string' && object[key].trim())
		.map(({ key, label }) => ({ key, label, value: object[key] }))
}

// External DTOs contain this safe attribution explicitly. Do not fall back
// to owner, member, user or agency fields, which are not a presentation contract.
export function scopedObjectSource(source) {
	if (!source || typeof source !== 'object') return null
	const name = [source.name, source.title].find(value => typeof value === 'string' && value.trim())
	return name ? { kind: source.kind, name } : null
}

// Replacing rather than merging is security relevant: a later, narrower DTO
// for the same Object must remove fields that are absent from that DTO.
export function replaceScopedObject(objects, objectId, scopedObject) {
	return objects.map(object => String(object.id) === String(objectId) ? scopedObject : object)
}
